import ItodoImage from "../../../elements/itodo-img";
import { NavLink, useParams } from "react-router-dom";
import { blogData } from "../../../../globals/blogData";

function SectionBlogSingle() {
    const { id } = useParams();
    const post = blogData[id];

    // If post doesn't exist, show error message
    if (!post) {
        return (
            <div className="blog-single-space">
                <div className="single-blog-post blog-detail m-b30">
                    <h2>Blog post not found</h2>
                    <p>The requested blog post could not be found.</p>
                    <NavLink to="/blogs" className="site-button">
                        Back to Blogs
                    </NavLink>
                </div>
            </div>
        );
    }

    // Get previous and next post IDs for navigation
    const postIds = Object.keys(blogData).map(Number).sort((a, b) => a - b);
    const currentIndex = postIds.indexOf(parseInt(id));
    const prevPostId = currentIndex > 0 ? postIds[currentIndex - 1] : null;
    const nextPostId = currentIndex < postIds.length - 1 ? postIds[currentIndex + 1] : null;

    return (
        <>
            <div className="blog-single-space">
                {/* BLOG START */}
                <div className="sx-post-media sx-img-effect img-reflection m-b30">
                    <ItodoImage src={post.image} alt={post.title} />
                </div>
                <div className="single-blog-post blog-detail m-b30">
                    <div className="sx-post-meta ">
                        <ul>
                            <li className="post-date">
                                <i className="fa fa-calendar" />
                                {post.date}
                            </li>
                            <li className="post-author">
                                <i className="fa fa-comments" />
                                {post.comments} Comments
                            </li>
                        </ul>
                    </div>
                    <div className="sx-post-title ">
                        <h2 className="post-title">{post.title}</h2>
                    </div>
                    <div className="sx-post-text">
                        <p>{post.shortdesc}</p>
                        <p>{post.fulldesc}</p>
                    </div>
                    
                    <div className="autor-post-tag-share">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="widget_tag_cloud single-post-tag">
                                    <h6 className="tagcloud">Tags:</h6>
                                    <div className="tagcloud">
                                        <NavLink to="/services">Data Science</NavLink>
                                        <NavLink to="/services">Business Intelligence</NavLink>
                                        <NavLink to="/services">Technology</NavLink>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="widget_social_inks sx-social-icons ">
                                    <ul className="d-flex">
                                        <li><a href="https://www.facebook.com/"><i className="fa fa-facebook" /></a></li>
                                        <li><a href="https://www.instagram.com/"><i className="fa fa-instagram" /></a></li>
                                        <li><a href="https://twitter.com/"><i className="fa fa-twitter" /></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <div className="s-post-pagination-control previous-next previous next">
                        {prevPostId && (
                            <div className="paging-left paging-item">
                                <div className="paging-content">
                                    <NavLink className="paging-link" to={`/blogs/detail/${prevPostId}`}>
                                        <i className="fa  fa-long-arrow-left" />
                                    </NavLink>
                                    <div className="paging-content-inner">
                                        <NavLink className="paging-link2" to={`/blogs/detail/${prevPostId}`}>Previous Post</NavLink>
                                        <h4 className="paging-title">
                                            <NavLink to={`/blogs/detail/${prevPostId}`}>{blogData[prevPostId].title}</NavLink>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        {nextPostId && (
                            <div className="paging-right paging-item">
                                <div className="paging-content reverse">
                                    <NavLink className="paging-link" to={`/blogs/detail/${nextPostId}`}>
                                        <i className="fa  fa-long-arrow-right" />
                                    </NavLink>
                                    <div className="paging-content-inner">
                                        <NavLink className="paging-link2" to={`/blogs/detail/${nextPostId}`}>Next Post</NavLink>
                                        <h4 className="paging-title">
                                            <NavLink to={`/blogs/detail/${nextPostId}`}>{blogData[nextPostId].title}</NavLink>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionBlogSingle;